// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// MUI components
import Box from '@mui/material/Box';

// Section for import custom components --------------------------------------------------------------------------------
import SelectedCitiesProvider from '@providers/MansionNavigation/SelectedCitiesProvider';
import CitiesList from './CitiesList';
import CitiesSearch from './CitiesSearch';

export default function CitiesSelector(props: any) {
  const { selectedPrefecture } = props;
  const { modePrefSelect } = props;

  // Section for render component --------------------------------------------------------------------------------------
  return (
    // Section for render Mobile mode ----------------------------------------------------------------------------------
    <SelectedCitiesProvider>
      <Box className="md:pb-10">
        <CitiesList modePrefSelect={modePrefSelect} selectedPrefecture={selectedPrefecture} />
        <CitiesSearch modePrefSelect={modePrefSelect} selectedPrefecture={selectedPrefecture} />
      </Box>
    </SelectedCitiesProvider>
  );
}
